import React from 'react'
import { shallow } from 'zustand/shallow'

import { useAppStore } from '@runtime/core/store/appStore'
import { startUserSessionSync } from '@runtime/core/user/syncUserSession'

export * from '@runtime/core/user/userModel'

type UserProviderProps = {
  children: React.ReactNode
}

// Backward-compatible wrapper (the app no longer requires React Context for user state).
export function UserProvider({ children }: UserProviderProps) {
  const authToken = useAppStore((s) => s.authToken)
  React.useEffect(() => {
    if (authToken) return startUserSessionSync(authToken)
  }, [authToken])

  return <>{children}</>
}

// Backward-compatible hook: keep the old API surface while using Zustand underneath.
export function useUser() {
  return useAppStore(
    (s) => ({
      user: s.user,
      authToken: s.authToken,
      loginOpen: s.ui.loginOpen,
      setLoginOpen: s.setLoginOpen,
      setAuthToken: s.setAuthToken,
      setUserFromServer: s.setUserFromServer,
      updateProfile: s.updateProfile,
      logout: s.logout,
      recordGame: s.recordGame,
      recordGameForOwner: s.recordGameForOwner,
      toggleFavoriteGame: s.toggleFavoriteGame,
    }),
    shallow,
  )
}
